// Types
import {
  InvalidAddressFormGetConfig,
  InvalidAddressFormProps,
} from '@components/invalid-address-form/InvalidAddressForm.types';

// Config
export const ADDRESS_BOOK_ADDRESS_FORM_ID = 'addressBookAddressForm';

export default function getAddressBookAddressFormConfig(
  getConfig: InvalidAddressFormGetConfig,
  editMode: boolean = false,
) {
  return (params: InvalidAddressFormProps) => {
    const config = getConfig({ ...params, editMode });

    return {
      submitButton: 'Use address',
      ...config,
      id: ADDRESS_BOOK_ADDRESS_FORM_ID,
    };
  };
}
